import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const FullscreenLoader = () => (
  <div style={{
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <video
      src="/loading-spinner.mp4"
      autoPlay
      loop
      muted
      playsInline
      disablePictureInPicture
      disableRemotePlayback
      controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
      style={{ width: 112, height: 112, objectFit: 'contain', pointerEvents: 'none' }}
      onError={(e) => {
        (e.target as HTMLVideoElement).style.display = 'none';
        (e.target as HTMLVideoElement).nextElementSibling?.removeAttribute('style');
      }}
    />
    <span style={{ display: 'none', color: 'var(--ant-color-text)' }}>
      <Spin indicator={<LoadingOutlined spin />} />
    </span>
  </div>
);

export default FullscreenLoader;
